import { buildDownloadUrl } from '../../utils/apiHelperUtils';

export default function ExportButton(props) {
  const { params, className, label, path, onClickHook, totalRecords, exportLimit } = props

  return (
    <>
      {totalRecords > exportLimit ?
        <a href="#" className={`btn ${className}`} onClick={() => alert(`Export limit is ${exportLimit}, Please adjust your filters or contact support@itrust.io for more detail.`)}>{label}</a> :
        <a download className={`btn ${className}`} href={buildDownloadUrl(path, params)} onClick={onClickHook}>{label}</a>
      }
    </>
  )
}